import { render } from "./releaseDocument.vue?vue&type=template&id=795f0ecc"
import script from "./releaseDocument.vue?vue&type=script&lang=js"
export * from "./releaseDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__